import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CommonService } from 'src/app/core/services/common-service';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
    selector: 'app-uwmailaccess',
    templateUrl: './uwmailaccess.component.html',
    styleUrls: ['./uwmailaccess.component.css'],
    standalone: false
})
export class UwmailaccessComponent implements OnInit {
  newQuoteService: any;
  params: any;
  displayMessage: string;
  ppFLag: boolean;

  constructor(private notifyService: NotificationService, private commonService: CommonService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      //console.log(params);
      if (params.action == 'accept') {
        this.Accept(params);

      } else {
        this.Reject(params);
      }
    });

  }

  Accept(params) {
    if (params.proposalNumber.substring(0, 2) == 'EN') {
      this.ppFLag = true
    } else {
      this.ppFLag = false
    }
    this.commonService.acceptMail(params.proposalNumber, params.lob)
      .subscribe((res) => {
        if (this.ppFLag) {
          if (res === 'Proposal is already accepted by Underwriter') {
            this.displayMessage = 'Endorsement is already accepted by Underwriter';
            this.notifyService.showSuccess('Endorsement is already Accepted', 'Email Notification');
          }
          else if (res === 'Approved Successfully') {
            this.displayMessage = 'Accepted Succesfully';
            this.notifyService.showSuccess('Accepted Succesfully', 'Email Notification');
          } else if (res === 'Proposal is already rejected by Underwriter') {
            this.displayMessage = 'Endorsement is already rejected by Underwriter';
            this.notifyService.showSuccess('Endorsement is already Rejected', 'Email Notification');
          }
        } else {
          if (res === 'Proposal is already accepted by Underwriter') {
            this.displayMessage = 'Proposal is already accepted by Underwriter';
            this.notifyService.showSuccess('Proposal is already Accepted', 'Email Notification');
          }
          else if (res === 'Approved Successfully') {
            this.displayMessage = 'Accepted Succesfully';
            this.notifyService.showSuccess('Accepted Succesfully', 'Email Notification');
          } else if (res === 'Proposal is already rejected by Underwriter') {
            this.displayMessage = 'Proposal is already rejected by Underwriter';
            this.notifyService.showSuccess('Proposal is already Rejected', 'Email Notification');
          }
        }
        setTimeout(() => {
          window.close();

        }, 5000);
      }, (error) => {
        if (this.ppFLag) {
          if (error == 'Please verify the input details: {} ') {
            this.notifyService.showError('Endorsement is already accepted/rejected, please login to partner portal and reverify', '');
          }
          else {
            this.notifyService.showError('Technical error', 'Email Notification');
          }
        } else {
          if (error == 'Please verify the input details: {} ') {
            this.notifyService.showError('Proposal is already accepted/rejected, please login to partner portal and reverify', '');
          }
          else {
            this.notifyService.showError('Technical error', 'Email Notification');
          }
       }
        setTimeout(() => {
          window.close();

        }, 5000);


      });

  }
  Reject(params) {
    if (params.proposalNumber.substring(0, 2) == 'EN') {
      this.ppFLag = true
    } else {
      this.ppFLag = false
    }
    this.commonService.rejectMail(params.proposalNumber, params.lob)
      .subscribe((res) => {
        if (this.ppFLag) {
          if (res === 'Rejected Successfully') {
            this.displayMessage = 'Rejected  Succesfullly';
            this.notifyService.showSuccess('Rejected  Succesfullly', 'Email Notification');
          } else if (res === 'Proposal is already rejected by Underwriter') {
            this.displayMessage = 'Endorsement is already rejected by Underwriter';
            this.notifyService.showSuccess('Endorsement is already Rejected', 'Email Notification');
          } else if (res === 'Proposal is already accepted by Underwriter') {
            this.displayMessage = 'Endorsement is already accepted by Underwriter';
            this.notifyService.showSuccess('Endorsement is already Approved', 'Email Notification');
          } else {
            this.notifyService.showSuccess(res, 'Email Notification');
          }
        } else {
          if (res === 'Rejected Successfully') {
            this.displayMessage = 'Rejected  Succesfullly';
            this.notifyService.showSuccess('Rejected  Succesfullly', 'Email Notification');
          } else if (res === 'Proposal is already rejected by Underwriter') {
            this.displayMessage = 'Proposal is already rejected by Underwriter';
            this.notifyService.showSuccess('Proposal is already Rejected', 'Email Notification');
          } else if (res === 'Proposal is already accepted by Underwriter') {
            this.displayMessage = 'Proposal is already accepted by Underwriter';
            this.notifyService.showSuccess('Proposal is already Approved', 'Email Notification');
          }
        }
        setTimeout(() => {
          window.close();

        }, 5000);

      }, (error) => {
        if (this.ppFLag) {
          if (error == 'Please verify the input details: {} ') {
            this.notifyService.showError('Endorsement is already accepted/rejected, please login to partner portal and reverify', '');
          }
          else {
            this.notifyService.showError('Technical error', 'Email Notification');
          }
        } else {
          if (error == 'Please verify the input details: {} ') {
            this.notifyService.showError('Proposal is already accepted/rejected, please login to partner portal and reverify', '');
          }
          else {
            this.notifyService.showError('Technical error', 'Email Notification');
          }
        }
        setTimeout(() => {
          window.close();

        }, 5000);


      });

  }


}
